/* Petal Post: minimum order + date gate.
   Carts need at least $100 to check out. Exceptions: carts with a subscription have no minimum,
   and carts with only Florist's Choice (the budget bouquet, plus its add-ons) need at least $80.
   Under $100, the message points shoppers to Florist's Choice.
   Checkout is also blocked until the cart has a date and the buyer's mobile number; if missing, a short form
   (date, time window, mobile, notes) appears above the checkout button.
   Delivery or pickup is chosen once, at checkout.
   Also makes add-to-cart wait for the date to be saved to the cart (fixes the first-visit lost-date race).
   Note: this guards the buttons, it cannot stop someone typing /checkout into the address bar. */
(function () {
  if (window.__ppCartMin) return;
  window.__ppCartMin = true;
  var MIN = 10000, MIN_BUDGET = 8000;
  var BUDGET_HANDLE = 'florists-choice';
  var BUDGET_URL = '/products/' + BUDGET_HANDLE;
  var DK = 'Delivery or pickup date', TK = 'Pickup or delivery time window', PK = 'Your phone number';
  var PHONE = '0418 859 997';
  var cart = null, timer = null, saving = false;
  var st = { date: '', time: '', phone: '', notes: '' };
  try { st.date = localStorage.getItem('pp-date') || ''; st.time = localStorage.getItem('pp-time') || ''; st.phone = localStorage.getItem('pp-phone') || ''; } catch (e) {}

  /* Make /cart/add wait for the date attributes save started by petal-date.js */
  var origFetch = window.fetch;
  window.fetch = function (u, o) {
    try {
      var url = typeof u === 'string' ? u : ((u && u.url) || '');
      if (url.indexOf('/cart/add') !== -1 && window.__ppDateSaved) {
        var p = window.__ppDateSaved;
        window.__ppDateSaved = null;
        var go = function () { return origFetch.call(window, u, o); };
        return Promise.resolve(p).then(go, go);
      }
    } catch (e) { /* fall through */ }
    return origFetch.apply(this, arguments);
  };

  function money(c) { var d = c / 100; return '$' + (Math.round(d) === d ? d.toFixed(0) : d.toFixed(2)); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function sydneyNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Sydney', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
      var o = {}; parts.forEach(function (p) { o[p.type] = p.value; });
      return { y: parseInt(o.year, 10), m: parseInt(o.month, 10), d: parseInt(o.day, 10), h: parseInt(o.hour, 10) % 24 };
    } catch (e) { var n = new Date(); return { y: n.getFullYear(), m: n.getMonth() + 1, d: n.getDate(), h: n.getHours() }; }
  }
  function addDays(s, n) { var t = new Date(Date.UTC(s.y, s.m - 1, s.d + n)); return t.getUTCFullYear() + '-' + pad(t.getUTCMonth() + 1) + '-' + pad(t.getUTCDate()); }
  function minDate() { var n = sydneyNow(); return addDays(n, n.h >= 20 ? 2 : 1); }
  function nice(v) { var d = new Date(v + 'T00:00:00'); return d.toLocaleDateString('en-AU', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }); }
  function phoneOk(v) { return String(v || '').replace(/[^0-9]/g, '').length >= 8; }

  function required(c) {
    var sub = false, hasMain = false, onlyBudget = true;
    (c.items || []).forEach(function (it) {
      if (it.product_type === 'Subscription') sub = true;
      if (it.product_type === 'Add-on') return;
      hasMain = true;
      if (it.handle !== BUDGET_HANDLE) onlyBudget = false;
    });
    if (sub) return 0;
    return (hasMain && onlyBudget) ? MIN_BUDGET : MIN;
  }
  function below() {
    return !!(cart && cart.item_count > 0 && cart.total_price < required(cart));
  }
  function missingDate() {
    var a = (cart && cart.attributes) || {};
    return !!(cart && cart.item_count > 0 && !(a[DK] && a[PK]));
  }
  function gated() { return below() || missingDate(); }

  function messageHtml(req) {
    var more = money(Math.max(0, req - cart.total_price));
    if (req === MIN_BUDGET) {
      return 'Florist’s Choice starts at ' + money(req) + '. Add ' + more + ' more to check out.';
    }
    return 'Our minimum order is ' + money(req) + '. Add ' + more + ' more, or choose a <a href="' + BUDGET_URL + '" style="text-decoration:underline">Florist’s Choice bouquet</a>, which uses more affordable flowers and starts at ' + money(MIN_BUDGET) + '.';
  }

  var css = document.createElement('style');
  css.textContent =
    '.pp-cartdate{margin:0 0 1.2rem;padding:1.2rem;border:1px solid rgba(var(--color-foreground),.3);border-radius:2px;font-size:1.3rem;text-align:left}' +
    '.pp-cd-title{margin:0 0 .4rem;font-size:1.4rem;font-weight:600;text-align:center}' +
    '.pp-cd-sub{margin:0 0 .8rem;text-align:center;opacity:.8}' +
    '.pp-cartdate label{display:block;margin-top:.8rem}' +
    '.pp-cartdate input,.pp-cartdate select{display:block;width:100%;margin-top:.3rem;padding:.8rem 1rem;font:inherit;border:1px solid rgba(var(--color-foreground),.35);border-radius:2px;background:transparent;color:inherit;box-sizing:border-box}' +
    '.pp-cartdate .button{margin-top:1rem;width:100%}' +
    '.pp-cd-err{margin:.8rem 0 0;color:#b3261e}';
  document.head.appendChild(css);

  function formEl() {
    var d = document.createElement('div');
    d.className = 'pp-cartdate';
    d.innerHTML =
      '<p class="pp-cd-title">When would you like it?</p>' +
      '<p class="pp-cd-sub">We need this before checkout. Need it sooner? Call or text ' + PHONE + '.</p>' +
      '<label>Delivery or pickup date<input type="date" data-f="date" min="' + minDate() + '"></label>' +
      '<label>Time window<select data-f="time"><option value="">Choose a time window</option><option>8am to 10am</option><option>10am to 12pm</option><option>12pm to 2pm</option><option>2pm to 4pm</option><option>4pm to 6pm</option><option>6pm to 7pm</option></select></label>' +
      '<label>Your mobile number<input type="tel" data-f="phone" maxlength="20" autocomplete="tel"></label>' +
      '<label>Delivery notes (optional)<input type="text" data-f="notes" maxlength="160" autocomplete="off"></label>' +
      '<p class="pp-cd-err" role="alert" hidden></p>' +
      '<button type="button" class="button button--primary pp-cd-save">Save and continue</button>';
    d.querySelectorAll('[data-f]').forEach(function (el) {
      var v = st[el.getAttribute('data-f')] || '';
      if (el.value !== v) el.value = v;
    });
    return d;
  }

  function apply() {
    if (!cart) return;
    var b = below(), md = missingDate();
    var req = required(cart);
    var html = b ? messageHtml(req) : '';
    document.querySelectorAll('.cart__ctas').forEach(function (box) {
      var m = box.parentNode.querySelector('.pp-cartmin-msg');
      if (b) {
        if (!m) {
          m = document.createElement('p');
          m.className = 'pp-cartmin-msg';
          m.setAttribute('role', 'alert');
          m.style.cssText = 'margin:0 0 1.2rem;font-size:1.4rem;text-align:center;';
          box.parentNode.insertBefore(m, box);
        }
        if (m.dataset.k !== html) { m.innerHTML = html; m.dataset.k = html; }
      } else if (m) {
        m.remove();
      }
      var f = box.parentNode.querySelector('.pp-cartdate');
      if (md) {
        if (!f) box.parentNode.insertBefore(formEl(), box);
      } else if (f) {
        f.remove();
      }
      box.querySelectorAll('button[name="checkout"]').forEach(function (btn) {
        var want = b || md || cart.item_count === 0;
        if (btn.disabled !== want) btn.disabled = want;
      });
    });
    document.querySelectorAll('.additional-checkout-buttons').forEach(function (e) {
      var d = (b || md) ? 'none' : '';
      if (e.style.display !== d) e.style.display = d;
    });
  }
  function load() {
    if (saving) return;
    origFetch.call(window, '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; apply(); })
      .catch(function () {});
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(load, 300); }

  function showErr(d, msg) {
    var e = d.querySelector('.pp-cd-err');
    e.textContent = msg; e.hidden = !msg;
  }
  function save(d) {
    var msg = '';
    if (!st.date) msg = 'Please choose a date.';
    else if (st.date < minDate()) msg = 'Online orders close at 8pm the day before. For anything sooner, call or text ' + PHONE + '.';
    else if (!st.time) msg = 'Please choose a time window.';
    else if (!phoneOk(st.phone)) msg = 'Please add your mobile number so we can reach you about this order.';
    showErr(d, msg);
    if (msg) return;
    var a = {};
    a[DK] = nice(st.date) + ' (' + st.date + ')';
    a[TK] = st.time;
    a[PK] = st.phone.trim();
    a['Delivery notes'] = st.notes.trim();
    saving = true;
    var btn = d.querySelector('.pp-cd-save'); btn.disabled = true;
    origFetch.call(window, (window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: a })
    }).then(function (r) { return r.json(); }).then(function (c) {
      saving = false; btn.disabled = false;
      if (c && c.attributes) { cart = c; apply(); } else { load(); }
      try { localStorage.setItem('pp-date', st.date); localStorage.setItem('pp-time', st.time); localStorage.setItem('pp-phone', st.phone.trim()); } catch (e) {}
    }).catch(function () {
      saving = false; btn.disabled = false;
      showErr(d, 'Sorry, that did not save. Please try again.');
    });
  }

  document.addEventListener('input', onField);
  document.addEventListener('change', onField);
  function onField(e) {
    var el = e.target, d = el && el.closest ? el.closest('.pp-cartdate') : null;
    var k = el && el.getAttribute ? el.getAttribute('data-f') : null;
    if (!d || !k) return;
    st[k] = el.value;
    showErr(d, '');
  }

  document.addEventListener('click', function (e) {
    var sv = e.target && e.target.closest ? e.target.closest('.pp-cd-save') : null;
    if (sv) { e.preventDefault(); e.stopPropagation(); save(sv.closest('.pp-cartdate')); return; }
    var t = e.target && e.target.closest ? e.target.closest('button[name="checkout"], a[href*="/checkout"]') : null;
    if (t && gated()) {
      e.preventDefault(); e.stopImmediatePropagation();
      if (!below() && !document.querySelector('.pp-cartdate')) window.location.href = '/cart';
    }
  }, true);
  document.addEventListener('submit', function (e) {
    if (e.submitter && e.submitter.name === 'checkout' && gated()) {
      e.preventDefault(); e.stopImmediatePropagation();
      if (!below() && !document.querySelector('.pp-cartdate')) window.location.href = '/cart';
    }
  }, true);

  function start() {
    load();
    if (window.MutationObserver) {
      new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          var n = list[i].target;
          if (n && n.closest && (n.closest('.pp-cartmin-msg') || n.closest('.pp-cartdate'))) continue;
          schedule();
          return;
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
